import apiClient from './client';

// GET /api/agents
// Query: region, availability, is_locked, is_active
export async function fetchAgents(params = {}) {
  const response = await apiClient.get('/agents', { params });
  return response.data;
}

// GET /api/agents/:id
export async function getAgent(id) {
  const response = await apiClient.get(`/agents/${id}`);
  return response.data;
}

// POST /api/agents — role: admin
export async function createAgent(payload) {
  const response = await apiClient.post('/agents', payload);
  return response.data;
}

// PUT /api/agents/:id — role: admin
export async function updateAgent(id, payload) {
  const response = await apiClient.put(`/agents/${id}`, payload);
  return response.data;
}

// GET /api/agents/:id/capacity
export async function getAgentCapacity(id) {
  const response = await apiClient.get(`/agents/${id}/capacity`);
  return response.data;
}

// POST /api/agents/:id/assign
// Body: { lead_ids: [...], reason: string }
export async function assignLeads(agentId, leadIds, reason = '') {
  const response = await apiClient.post(`/agents/${agentId}/assign`, {
    lead_ids: leadIds,
    reason,
  });
  return response.data;
}

// POST /api/agents/:id/reassign
// Body: { lead_ids: [...], from_agent_id: string, reason: string }
export async function reassignLeads(toAgentId, leadIds, fromAgentId, reason = '') {
  const response = await apiClient.post(`/agents/${toAgentId}/reassign`, {
    lead_ids: leadIds,
    from_agent_id: fromAgentId,
    reason,
  });
  return response.data;
}
